import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import Dialog from '../../../../atoms/feedback/Dialog'
import { useVisitorRegistrationFormWorkerDeleteDialog } from '../../../../../hooks/useDialog'
import { FlexColumn } from '../../../../atoms/layout/Flex'
import Button from '../../../../atoms/inputs/Button'
import { CompanyActions } from '../../../../../store/company'
import Label from '../../../../atoms/display/Label'

export default function VisitorRegistrationFormWorkerDeleteDialog() {
  const { state, close } = useVisitorRegistrationFormWorkerDeleteDialog()
  const dispatch = useDispatch()

  const handleDelete = useCallback(() => {
    if (state) {
      dispatch(CompanyActions.deleteVisitorRegistrationFormWorker({ workerId: state?.worker.id }))
    }
  }, [dispatch, state])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="労働者情報の削除"
      actions={
        <Button type="submit" color="caution" onClick={handleDelete}>
          削除
        </Button>
      }
    >
      <FlexColumn>
        <Label text="以下の労働者情報を削除しますか？" />
        {state && (
          <FlexColumn space={0}>
            <Label text={state.worker.kana} variant="caption" />
            <Label text={state.worker.name} />
          </FlexColumn>
        )}
      </FlexColumn>
    </Dialog>
  )
}
